import {
  GetAuthorizedLogisticsPartiesInput,
  ServiceProviderIdentifierType,
} from '@amzn/coral_com-amazon-carrierlogisticswebserver-model';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAuthorizedLps } from '../../actions/lp';
import { GET_AUTHORIZED_LPS_REQUEST } from '../../actions/lp/actionTypes';
import { getAuthorizedLpsSelector } from '../../actions/lp/selectors';

export function useAuthorizedLps() {
  const dispatch = useDispatch();
  const authorizedLps = useSelector(getAuthorizedLpsSelector);

  useEffect(() => {
    dispatch(
      getAuthorizedLps.request(
        {
          getAuthorizedLpsInput: GetAuthorizedLogisticsPartiesInput.clone({
            serviceProviderIdentifierType:
              ServiceProviderIdentifierType.LOGISTICS_PARTY_ID,
          }),
        },
        GET_AUTHORIZED_LPS_REQUEST
      )
    ); // To Fetch All Lps details
  }, [dispatch]);

  return authorizedLps;
}
